import { FieldProps } from "@rjsf/utils";
import { area, polygon } from "@turf/turf";

import { useFileDescriptorQuery } from "@/features/project-file-preview";
import { getRanaWidgetFromProperty } from "@/features/project-process-run-form";
import { useFileQuery } from "@/queries/query-file";
import { isTypedDescriptor } from "@/utils/is-descriptor-type";

export const useAreaSize = (props: FieldProps) => {
  const { schema, formData: currentCellSize } = props;

  const ranaWidget = getRanaWidgetFromProperty(schema, "cell_size");
  const extentSource = ranaWidget?.extent_source;
  const bytesPerCell = ranaWidget?.bytes_per_cell ?? 4;
  const studyAreaFileId = extentSource
    ? props.formContext?.allFormData?.[extentSource]?.id
    : undefined;

  const { data: studyAreaFile, isLoading: isLoadingFile } = useFileQuery(studyAreaFileId);
  const { data: descriptor, isLoading: isLoadingDescriptor } = useFileDescriptorQuery(
    studyAreaFile?.descriptorId
  );
  const isLoading = isLoadingFile || isLoadingDescriptor;

  const bbox =
    descriptor && isTypedDescriptor(descriptor, "vector") ? descriptor.meta.envelope : undefined;
  const knowsAreaSize = !!bbox;
  const areaSqMeters = knowsAreaSize
    ? area(
        polygon([
          [
            [bbox[0], bbox[1]], // bottom-left
            [bbox[0], bbox[3]], // top-left
            [bbox[2], bbox[3]], // top-right
            [bbox[2], bbox[1]], // bottom-right
            [bbox[0], bbox[1]], // close the polygon
          ],
        ])
      )
    : 0;

  const currentBytes = Math.ceil(areaSqMeters / currentCellSize) * bytesPerCell;

  return { isLoading, knowsAreaSize, currentBytes };
};
